import { render } from "./RowsPerPageDropdown.vue?vue&type=template&id=1f6d73fa"
import script from "./RowsPerPageDropdown.vue?vue&type=script&lang=js"
export * from "./RowsPerPageDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script